import { render, staticRenderFns } from "./PasswordFind.vue?vue&type=template&id=2893c8a1&scoped=true&"
import script from "./PasswordFind.vue?vue&type=script&lang=js&"
export * from "./PasswordFind.vue?vue&type=script&lang=js&"
import style0 from "./PasswordFind.vue?vue&type=style&index=0&id=2893c8a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893c8a1",
  null
  
)

export default component.exports